angular.module('empower.uploadDocument')
    .controller('uploadDocumentController', ['$rootScope', '$scope', '$timeout', '$filter', '$window', 'popupService', 'commonConst', 'highlighter', 'documentUploadTypeConst', 'uploadDocumentWording', 'uploadDocumentService', 'uploadFileWording', 'documentSelectionsConst', 'httpService',
        function ($rootScope, $scope, $timeout, $filter, $window, popupService, commonConst, highlighter, documentUploadTypeConst, uploadDocumentWording, uploadDocumentService, uploadFileWording, documentSelectionsConst, httpService) {
            UploadFileExtension($scope, {
                // $form: document.querySelector('#fileupload'),
                submitText: 'Uploading ...',
                fnSubmitFile: fnSubmitFile,
                fnFileUploadStop: fnFileUploadStop,
                fnFormValidation: fnFormValidation
            }, uploadFileWording, $window, httpService);
            $scope.baseUploadPath = 'uploads';
            $scope.pageName = 'Upload Documents';

            $scope.pageForms = {};
            
            $scope.pageBreadcrumbs = [{url: '/', title: 'Home'}, {url: null, title: 'Upload Documents'}];

            if ($rootScope.user.IsClaimant) {
                $scope.documentUploadTypes = documentUploadTypeConst.WORKER;
            } else {
                if ($rootScope.user.IsNsiUser) {
                    $scope.documentUploadTypes = documentUploadTypeConst.NSI_EMPLOYER;
                } else {
                    $scope.documentUploadTypes = documentUploadTypeConst.EMPLOYER;
                }
            }
            $scope.travelTypes = documentSelectionsConst.TRAVEL_TYPES;

            $scope.isNsiEmployer = $rootScope.user.IsNsiUser && !$rootScope.user.IsClaimant;

            $scope.selectedData = {
                policy: null,
                claim: null
            };

            $scope.formData = {
                policyId: null,
                claimId: null,
                documentType: $scope.documentUploadTypes[0],
                travelDate: null,
                travelForm: null,
                travelTo: null,
                doctorName: null,
                travelType: $scope.travelTypes[0].id,
                travelCost: null,
                uploadSession: $scope.generateUploadSession()
            }

            if (!$rootScope.user.IsClaimant) {
                $scope.$on('policySelectionChanged', function (event, policy) {
                    if (!policy ||
                        (!!$scope.selectedData.claim &&
                            $scope.selectedData.claim.PolicyId !== policy.EmployerId)) {
                        $scope.$broadcast('resetClaimSelection');
                    }

                    if($scope.formData.policyId != (policy? policy.EmployerId : null)) {
                        $scope.$broadcast('reloadUploadDocumentHistory', {
                            policyId: !!policy ? policy.EmployerId : null,
                            claimId: null
                        });
                    }
                });
            }


            $scope.init = function () {
            }

            $scope.$on('claimSelectionChanged', function (event, claim) {
                if (!!claim && claim.ClaimId) { 
                    $scope.$broadcast('setPolicySelection', new PolicyModel(claim));
                }

                if($scope.formData.claimId != (claim? claim.ClaimId : null)) {
                    $scope.$broadcast('reloadUploadDocumentHistory', {
                        policyId: $scope.formData.policyId,
                        claimId: !!claim ? claim.ClaimId : null
                    });
                }
            });

            $scope.showDocumentTypeSpecification = function () {
                return $scope.formData.documentType === 'Other';
            } // showDocumentTypeSpecification

            $scope.showTravelExpensesForm = function() {
                return $scope.formData.documentType === 'Travel';
            }

            $scope.aClicked = false;
            $scope.selectFiles = function (f) {
                $timeout(function () {
                    if (!$scope.aClicked) {
                        angular.element(f).trigger('click');
                    }
                    $scope.aClicked = false;
                }, 100);

            } // selectFiles
            $('body').on('click', '.upload-file', function () {
                $scope.aClicked = true;
            })


            $scope.removeFile = function (file, queue) {
                event.stopPropagation();
                event.preventDefault();
                file.$cancel();
                if (queue.length == 0) {
                    $scope.clearError();
                    $scope.uploadControl.allowSubmit = false;
                }
                $scope.deleteFileUpload(file);
            } // removeFile


            $scope.submitUploadDocument = function () {
                $timeout(function() {
                    angular.element(document.activeElement).blur();
                });

                if ($scope.fileData && $scope.fileData.scope.queue.length > 0) {
                    $scope.submitFile(this);
                } else {
                    $scope.saveUploadInfo();
                } 
            }

            function fnSubmitFile() {
                $scope.uploadResult.hasError = false;
                $scope.uploadControl.isProcessing = true;
                $scope.uploadControl.allowAddFile = false;
                $scope.uploadControl.allowSubmit = false;
                $scope.uploadControl.submitText = 'Uploading...';
            } // fnSubmitFile

            function fnFileUploadStop(e) {
                if ($scope.uploadResult.hasError) {
                    var uploadError = $scope.getFileUploadError();
                    popupService.showValidationServerErrors(uploadError, undefined, reload);

                } else {
                    $scope.saveUploadInfo();
                }
            }; // fnFileUploadStop

            function reload(reloadHistories) {

                $scope.formData.uploadSession = $scope.generateUploadSession();
               
                $scope.formData.comment = '';
                $scope.formData.travelDate = '';
                $scope.formData.travelForm = '';
                $scope.formData.travelTo = '';
                $scope.formData.doctorName = '';
                $scope.formData.travelCost = '';
                //reset upload file
                $scope.uploadControl.totalSize = 0;
                $scope.uploadControl.allowSubmit = false;
                $scope.uploadControl.allowAddFile = true;
                $scope.uploadControl.submitText = 'Upload';
                if ($scope.fileData) {
                    //must in timeout because IE cause some strange bug...
                    $timeout(function () {
                        $scope.fileData.scope.queue.length = 0;
                    });
                }

                if (!!reloadHistories) {
                    $scope.$broadcast('reloadUploadDocumentHistory', {
                        policyId: $scope.formData.policyId,
                        claimId: $scope.formData.claimId
                    });
                }

                $scope.clearError();
                $scope.pageForms.fileuploadForm.$setPristine();
                $scope.pageForms.fileuploadForm.$setValidity();
                $scope.pageForms.fileuploadForm.$setUntouched();
                popupService.hide();
            } // reload

            function fnFormValidation() {
                if (!$scope.formData.policyId && !$scope.formData.claimId) {
                    highlighter.highlightFields('policy-id');
                    highlighter.highlightFields('claim-id');
                    popupService.showExternalError(uploadDocumentWording.POLICY_OR_CLAIM_REQUIRED, true);
                    return false;
                }

                return true;
            } // validateFormData

            $scope.isFormValid = function() {
                if($scope.formData.documentType !== 'Travel') {
                    return ($scope.formData.policyId || $scope.formData.claimId) 
                        && ($scope.fileData && $scope.fileData.scope.queue.length > 0);
                } else {
                    var result = ($scope.formData.policyId || $scope.formData.claimId) 
                        && ($scope.formData.travelDate && $scope.formData.travelForm && $scope.formData.travelTo 
                            && $scope.formData.doctorName && $scope.formData.travelType && $scope.formData.travelCost);
                    // personal car
                    if($scope.formData.travelType === $scope.travelTypes[0].id) {
                        return result;
                    } else {
                        return result && ($scope.fileData && $scope.fileData.scope.queue.length > 0);
                    }
                }
            }

            $scope.saveUploadInfo = function() {
                uploadDocumentService.saveDocumentUploadInfo({
                    UploadSession: $scope.formData.uploadSession,
                    DocumentType: $scope.formData.documentType,
                    PolicyId: $scope.formData.policyId,
                    Claim: $scope.selectedData.claim,
                    Comment: $scope.formData.comment,
                    TravelDate: $scope.formData.travelDate,
                    TravelForm: $scope.formData.travelForm,
                    TravelTo: $scope.formData.travelTo,
                    DoctorName: $scope.formData.doctorName,
                    TravelType: $scope.formData.travelType,
                    TravelCost: $scope.formData.travelCost,
                })
                .then(function (response) {
                    if (response.Success)
                        popupService.showText(uploadDocumentWording.UPLOAD_SUCCESS, undefined, reload.bind(this, true));

                    else if (angular.isDefined(response.ErrorMessage)) {
                        $scope.setError(response.ErrorMessage);
                        popupService.showError(response.ErrorMessage, undefined, reload);

                    } else {
                        var uploadError = getFileUploadError();
                        popupService.showValidationServerErrors(uploadError, undefined, reload);
                    }

                    //After submit need to get recent policies from rootscope
                    if (!!$scope.formData.claimId) {
                        sessionStorage.RecentlySelectedType = $filter('enstr64')(commonConst.CLAIM);
                        sessionStorage.Claim = $filter('enstr64')(JSON.stringify($scope.selectedData.claim));

                    } else if (!!$scope.formData.policyId) {
                        sessionStorage.RecentlySelectedType = $filter('enstr64')(commonConst.POLICY);
                        sessionStorage.Policy = $filter('enstr64')(JSON.stringify($scope.selectedData.policy));
                    }

                    $rootScope.getRecentPoliciesAndClaims();
                });
            }
        }
    ]);